import * as React from 'react'
import { Header } from './Header'
import { SignupFlow } from './signup-flow/SignupFlow'
import { Testimonial, TestimonialSize } from './Testimonial'

export const Signup = (): JSX.Element => {
  const [testimonialSize, setTestimonialSize] = React.useState<TestimonialSize>(
    TestimonialSize.Large
  )

  return (
    <main className='min-h-screen bg-background font-inter md:px-16 flex justify-center items-stretch'>
      <div className='max-w-[1400px] w-full md:w-auto grid grid-cols-12 auto-rows-min-auto items-center gap-x-8'>
        <Header />
        <SignupFlow setTestimonialSize={setTestimonialSize} />
        <Testimonial size={testimonialSize} />
      </div>
    </main>
  )
}
